export default __webpack_public_path__ + "static/media/grafema_minha-casa_03.05a6e0f7.jpg";